import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import ForecastContributors from "modules/analyze-composite-forecast-contributors"
import "./style.scss"

export default function AnalyzeForecastDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  selectedDate,
  selected,
  selectedValue,
  viewType,
  sortOrder,
  selectedContributorCategory,
  selectedContributorValue,
  showContributorCategory,
  hideContributorCategory,
  setSortOrder,
  openFactorProfile,
  openSecurityProfile,
  currentGrouping,
  setGrouping,
  showGroup,
  hideGroup,
  groupOrder,
  selectedGroup,
  selectedOption,
  forecastId,
  details,
  classifications,
  segment,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-forecast-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    <ForecastContributors {...{
      account,
      modelId,
      positionSetId,
      positionSetType,
      positionSetName,
      viewType,
      selectedContributorCategory,
      selectedContributorValue,
      showContributorCategory,
      hideContributorCategory,
      showGroup,
      hideGroup,
      selectedGroup,
      groupOrder,
      setGrouping,
      currentGrouping,
      sortOrder,
      setSortOrder: handleSort,
      selected,
      selectedValue,
      selectedDate,
      selectedOption,
      forecastId,
      details,
      classifications,
      segment,
      openSecurityProfile,
      openFactorProfile,
    }}
    />
  </div>
}

AnalyzeForecastDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  factorCategoryId: PropTypes.string.isRequired,
  factorCategoryName: PropTypes.string.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  showContributorCategory: PropTypes.func,
  hideContributorCategory: PropTypes.func,
  sortOrder: PropTypes.object,
  setSortOrder: PropTypes.func,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  forecastId: PropTypes.string,
  dailyForecastData: PropTypes.array.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  currentGrouping: PropTypes.object,
  setGrouping: PropTypes.func.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
}
